module.exports = __webpack_public_path__ + "static/media/nav-broker-hover.40bdfc59.svg";